export enum Origin {
  POPUP = 'popup',
  CLICK = 'click',
  UNKNOWN = 'unknown',
}
